/* eslint-disable react/no-unescaped-entities */
import React, { useContext } from 'react'
import { Box, Typography } from '@mui/material'

import { ScreenContext } from 'apps/utils/ScreenContext'
import { usePageTitle } from 'apps/utils/usePageTitle'
import SectionShell from 'apps/common/SectionShell'
import theme from 'theme'

import { useStyles } from './styles'

const repos = [
	{
		name: 'Wiki.js MCP Server',
		description: 'MCP server for Wiki.js — HTTP & STDIO transports, OAuth 2.1, per-user attribution.',
		url: 'https://github.com/act-sw/wikijs-mcp-server',
		available: true,
	},
	{
		name: 'GitHub Project Automations',
		description: 'Automations for GitHub Projects workflows.',
		available: false,
	},
	{
		name: 'AFK Slack Bot',
		description: 'Away/status management bot for Slack.',
		url: 'https://github.com/act-sw/afk-slack-bot',
		available: true,
	},
]

const RepoCard = ( { classes, name, description, url, available, isLaptop } ) => (
	<Box
		component={ available ? 'a' : 'div' }
		href={ available ? url : undefined }
		target={ available ? '_blank' : undefined }
		rel={ available ? 'noopener noreferrer' : undefined }
		className={ `${ classes.pentagon } ${ available ? classes.pentagonAvailable : '' }` }
	>
		<svg
			className={ classes.pentagonOutline }
			viewBox='0 0 100 95'
			preserveAspectRatio='none'
		>
			<polygon
				points='50,0 100,38 82,95 18,95 0,38'
				fill='none'
				stroke='var(--line)'
				strokeWidth='2'
				vectorEffect='non-scaling-stroke'
			/>
		</svg>
		<Typography fontWeight='700' fontSize={ isLaptop ? '18px' : '16px' } sx={{ textTransform: 'none' }}>
			{ name }
		</Typography>
		<Typography fontSize={ isLaptop ? '13px' : '12px' } color='var(--text-muted)' marginTop='8px' lineHeight={ 1.5 }>
			{ description }
		</Typography>
		<Typography
			fontSize={ isLaptop ? '11px' : '10px' }
			fontWeight='700'
			letterSpacing='0.06em'
			marginTop='16px'
			color={ available ? 'var(--ink)' : 'var(--text-muted)' }
			sx={{ textTransform: 'uppercase' }}
		>
			{ available ? 'View on GitHub' : 'Coming soon' }
		</Typography>
	</Box>
)

const OpenSource = () => {
	usePageTitle( 'Open Source — ACT Software' )
	const { isLaptop } = useContext( ScreenContext )
	const classes = useStyles()

	return (
		<SectionShell railLabel='Open'>
			<Box paddingRight={ theme.spacing( 6 ) }>
				<Typography variant='h1' textAlign='right' fontSize={ isLaptop ? '88px' : '60px' }>
					open source
				</Typography>
			</Box>
			<Box
				maxWidth={ isLaptop ? '740px' : '100%' }
				marginTop={ isLaptop ? '64px' : '32px' }
				marginBottom={ isLaptop ? '32px' : '16px' }
				marginLeft='auto'
				marginRight='auto'
				paddingLeft={ theme.spacing( 6 ) }
				paddingRight={ theme.spacing( 6 ) }
				sx={{
					fontSize: isLaptop ? '17px' : '15px',
					lineHeight: 1.7,
					color: 'var(--ink)',
					textAlign: isLaptop ? 'center' : 'left'
				}}
			>
				Like most developers on this planet, we've been relying on open-source tools for
				years. As a token of appreciation to the global open-source community, the ACT team
				decided to publish a couple of in-house tools we consider handy in our everyday
				teamwork.
			</Box>
			<Box
				className={ classes.grid }
				marginBottom={ isLaptop ? '64px' : '32px' }
				paddingLeft={ theme.spacing( 6 ) }
				paddingRight={ theme.spacing( 6 ) }
			>
				{ repos.map( repo => (
					<RepoCard key={ repo.name } classes={ classes } isLaptop={ isLaptop } { ...repo } />
				) ) }
			</Box>
		</SectionShell>
	)
}

export default OpenSource
